import { ReactNode } from 'react';

interface BadgeProps {
  children: ReactNode;
  variant?: 'primary' | 'secondary' | 'success' | 'warning' | 'error' | 'gray';
  size?: 'sm' | 'md';
  rounded?: boolean;
}

const variantClasses = {
  primary: 'bg-[var(--color-info-light)] text-[var(--color-primary)]',
  secondary: 'bg-orange-100 text-[var(--color-secondary-dark)]',
  success: 'bg-[var(--color-success-light)] text-[var(--color-success)]',
  warning: 'bg-[var(--color-warning-light)] text-[var(--color-warning)]',
  error: 'bg-[var(--color-error-light)] text-[var(--color-error)]',
  gray: 'bg-[var(--color-gray-100)] text-[var(--color-gray-600)]',
};

const sizeClasses = {
  sm: 'px-2 py-0.5 text-xs',
  md: 'px-3 py-1 text-sm',
};

export default function Badge({
  children,
  variant = 'gray',
  size = 'md',
  rounded = true,
}: BadgeProps) {
  return (
    <span
      className={`
        inline-flex items-center font-medium
        ${variantClasses[variant]}
        ${sizeClasses[size]}
        ${rounded ? 'rounded-[var(--radius-full)]' : 'rounded-[var(--radius-sm)]'}
      `}
    >
      {children}
    </span>
  );
}